"use client";

import Script from "next/script";
import React from "react";

const TrustpilotScript = () => {
  return (
    <Script
      id="trustpilot-bootstrap"
      src="//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
      strategy="afterInteractive"
      async
    />
  );
};

export default TrustpilotScript;
